// extracted by mini-css-extract-plugin
export default {"loading-spinner":"LoadingSpinner_loading-spinner__zDJ4O","spinner":"LoadingSpinner_spinner__GG1og"};